import React, { useState, useRef, useEffect } from "react";
import DropdownGrayIcon from "../../../images/home/dropdown-gray-icon.svg";
import FilterIcon from "../../../images/home/filter-icon.svg";

const SortDropdown = ({ handleSortChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Sort By");
  const [dropUp, setDropUp] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const options = [
    { key: "Relevance (a-z)", value: "Relevance" },
    { key: "Price: Low to High", value: "PriceLowToHigh" },
    { key: "Price: High to Low", value: "PriceHighToLow" },
  ];

  const handleSelect = (option) => {
    setSelected(option.key);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen && dropdownRef.current && buttonRef.current) {
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;
      const dropdownHeight = dropdownRect.height;
      setDropUp(dropdownHeight > spaceBelow);
    }
  }, [isOpen]);

  return (
    <div className="relative inline-block text-left">
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="sort-filter-dropdown-kl"
      >
        <div className="sort-filter-dropdown-desktop">
          {selected}
        </div>
        <img className="sort-filter-dropdown-icon-kl" src={DropdownGrayIcon} alt="" />
        <img className="sort-filter-dropdown-mobile" src={FilterIcon} alt="" />
      </button>
      {isOpen && (
        <div
          ref={dropdownRef}
          className={`sort-filter-dropdown-list-kl ${dropUp ? "sort-filter-dropdown-list-kl bottom-12" : "mt-2"
            }`}
        >
          {options.map((option, index) => (
            <div
              key={index}
              onClick={() => {
                handleSelect(option)
                handleSortChange(option.value)
              }}
              className="sort-filter-dropdown-items-kl cursor-pointer"
            >
              {option.key}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
